import styled from 'styled-components';

export const Wrapper = styled.div<{ width: string }>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 48px 24px;
  background-color: var(--colorWhite);
  border-radius: 8px;
  box-shadow: 0px 0px 15px -7px rgba(0, 0, 0, 0.32), 0px 0px 46px 8px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.24);
  color: var(--colorBlueGray1200);
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 24px;
  position: relative;

  svg {
    margin-bottom: 8px;
  }

  p:not(:last-child) {
    margin-bottom: 24px;
  }
`;
